import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import GreenButton from "../../common/button/greenButton";
import { cssProperties } from "../../utils/commonCssProperties";
import CommonTable from "./../../common/CommonTable";
import CloseButton from "../../common/button/closeButton";
import DangerButton from "../../common/button/DangerButton";
import BrowseUploadButton from "../../common/button/browseUploadButton";
import axios from "axios";
import { API_URL, NODE_ENV } from "../../utils/constants";
import { IoCloudUploadOutline } from "react-icons/io5";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import MauvelousPrimaryButton from "./../../common/button/mauvelousPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import venueActions from "../../redux/venue/actions";
import { useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import xlsx from "json-as-xlsx";
import commonActions from "../../redux/common/actions";

import { percentageValidation } from "../../utils/validation";
import { useForm } from "react-hook-form";

// let data = [
//   {
//     name: "Candidates",
//     value: "1256",
//   },
//   {
//     name: "Venues",
//     value: "324",
//   },
//   {
//     name: "Venue Capacity for batch",
//     value: "324",
//   },
// ];
// let data2 = [
//   {
//     name: "Non Allocated Candidates",
//     value: "1256",
//   },
//   {
//     name: "Diability Candidates",
//     value: "324",
//   },
// ];
// let tableData = [
//   {
//     course_name: "course_1",
//     candidate_count: 10245,
//     exam_date: "23/05/2024",
//     batch_no: 1,
//     first_preference: "-----",
//     second_preference: "-----",
//     third_preference: "-----",
//   },
//   {
//     course_name: "course_2",
//     candidate_count: 10245,
//     exam_date: "23/05/2024",
//     batch_no: 1,
//     first_preference: "-----",
//     second_preference: "-----",
//     third_preference: "-----",
//   },
// ];

let data = [
  {
    sheet: "Venue Master Template",
    columns: [
      { label: "Venue Id", value: "Venue Id" },
      { label: "Seats Availability", value: "Seats Availability" },
      { label: "Venue Name", value: "Venue Name" },
      { label: "Venue Type", value: "Venue Type" },
      { label: "Pincode", value: "Pincode" },
      { label: "Address Line 1", value: "Address Line 1" },
      { label: "Address Line 2", value: "Address Line 2" },
      { label: "Landmark", value: "Landmark" },
      { label: "Village", value: "Village" },
      { label: "City", value: "City" },
      { label: "Taluka", value: "Taluka" },
      { label: "District", value: "District" },
      { label: "State", value: "State" },
      { label: "Google Map Link", value: "Google Map Link" },
      { label: "Building Type", value: "Building Type" },
      { label: "Suitable For Pwd", value: "Suitable For Pwd" },

      // { label: "addressline2" },
    ],
    content: [
      {
        "Venue Id": "V70",
        "Seats Availability": 20,
        "Venue Name": "GALAXY INFORMATION TECHNOLOGY",
        "Venue Type": "Institute",
        Pincode: 442605,
        "Address Line 1":
          "CAMP AREA NEAR DURGA MATA TEMPLE DHANORA ROAD GADCHIROLI",
        Landmark: "DURGA MATA TEMPLE",
        Village: "Gadchiroli",
        City: "GADCHIROLI",
        Taluka: "Gadchiroli",
        District: "Gadchiroli",
        State: "Maharashtra",
        "Google Map Link": "",
        "Building Type": "Educational",
        "Suitable For Pwd": true,
      },
    ],
  },
];

let settings = {
  fileName: "venue template",
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
  RTL: false,
};

let callback = function (sheet) {};
let columnData = [
  {
    name: "Course Name",
    dataIndex: "coursename",
  },
  {
    name: "Candidate Count",
    dataIndex: "candidatecount",
  },
  {
    name: "Exam Date",
    dataIndex: "examdate",
  },
  {
    name: "Batch No",
    dataIndex: "batchno",
  },
  {
    name: "Allocated based on 1st preference",
    dataIndex: "preference1",
  },
  {
    name: "Allocated based on 2nd preference",
    dataIndex: "preference2",
  },
  {
    name: "Allocated based on 3rd preference",
    dataIndex: "preference3",
  },
  {
    name: "Allocated based on 4th preference",
    dataIndex: "preference4",
  },
  {
    name: "Manually Allocated Candidates",
    dataIndex: "preference5",
  },
];

const Index = () => {
  const socketRef = useRef(null);

  // const socket = io(`http://localhost:3001`);

  const [file, setFile] = useState(null);
  const [courseid, setCourseId] = useState(0);
  const [pcmb, setPcmb] = useState(0);
  const [open, setOpen] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const {
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({ mode: "all" });
  let formValues = watch();
  useEffect(() => {
    for (let key in formValues) {
      // setValue(key, formValues[key])
      // trigger(key)
    }
    // trigger()
  }, [formValues, setValue]);

  let male = parseFloat(watch("male")) || 0;
  let others = parseFloat(watch("others")) || 0;
  let general = parseFloat(watch("general")) || 0;
  let female = parseFloat(watch("female")) || 0;
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const [loading, setLoading] = useState(false);
  const [preferenceid, setPreferenceId] = useState(0);
  const [isLogicApplied, setIsLogicApplied] = useState("0");
  const [logic, setLogic] = useState(1);
  const id = useLocation()?.state?.id;

  const dispatch = useDispatch();
  const { courseList } = useSelector((state) => state.masterReducer);
  const {
    candidateCount,
    venueDetails,
    seatAllocationData,
    candidateAllocationDetails,
    categoriesOfCourse,
  } = useSelector((state) => state.venueReducer);

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const categories = useMemo(() => {
    let data = [];
    categoriesOfCourse?.forEach((item) => {
      data.push({
        label: item.category,
        value: item.categoryid,
        id: `cat_${item.categoryid}`,
      });
    });
    return data;
  }, [categoriesOfCourse]);
  let getDataInterval = (courseid, currentVenueId) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("listenstatus", { courseid, currentVenueId });
    }, 10000);
    return intervalId;
  };
  useEffect(() => {
    socketRef.current = io(
      `${API_URL}`,
      NODE_ENV === "production" && {
        path: "/api/socket.io",
        //     transports: ['websocket', 'polling'],
        // reconnection: true,
        // reconnectionAttempts: 5,
        // reconnectionDelay: 1000
      }
    );
    return () => (socketRef.current = null);
  }, []);
  useEffect(() => {
    socketRef?.current?.on("listenmessage", (message) => {
      // let data = message?.data
      if (message?.statusCode === 200) {
        let statustext = message?.data?.trim();
        if (statustext) {
          if (statustext?.toLowerCase() !== "completed") {
            setStatusModalOpen({
              open: true,
              statustext:
                statustext?.trim() !== "" && statustext !== null
                  ? statustext
                  : statusModalopen.statustext,
            });
          } else {
            setStatusModalOpen({
              open: false,
              statustext:
                statustext?.toLowerCase() !== "completed"
                  ? ""
                  : statusModalopen.statustext,
            });

            dispatch({
              type: venueActions.GET_SEAT_ALLOCATION,
              payload: { courseid },
            });
            dispatch({
              type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
              payload: { courseid },
            });
            clearInterval(intervalId);
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "success",
                show: true,
                message: "seat allocated successfully",
              },
            });

            setTimeout(function () {
              dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "success",
                  show: false,
                  message: null,
                },
              });
            }, 2000);
          }
        }
        //  else {
        //   setStatusModalOpen({
        //     open: false,
        //     statustext: "",
        //   });
        // }
      }
    });
    return () => socketRef?.current?.off("listenmessage");
  }, [courseid, dispatch, intervalId, socketRef]);
  useEffect(() => {
    // id ? setCourseId(id) : setCourseId(0);
    id &&
      dispatch({
        type: venueActions.GET_VENUE_DETAILS,
        payload: { courseid: id },
      });
    id &&
      dispatch({
        type: venueActions.GET_CANDIDATE_COUNT,
        payload: { courseid: id },
      });
    id &&
      dispatch({
        type: venueActions.GET_SEAT_ALLOCATION,
        payload: { courseid: id },
      });
    id &&
      dispatch({
        type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
        payload: { courseid: id },
      });
  }, [id, dispatch]);
  // useEffect(() => {
  //   if (courseid > 0) {
  //     dispatch({
  //       type: venueActions.GET_VENUE_DETAILS,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_CANDIDATE_COUNT,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_SEAT_ALLOCATION,
  //       payload: { courseid: courseid },
  //     });
  //     dispatch({
  //       type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
  //       payload: { courseid },
  //     });
  //   }
  // }, [courseid, dispatch]);
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: venueActions.GET_SEAT_ALLOCATION_DETAILS });
    return () => {
      dispatch({
        type: venueActions.GET_CANDIDATE_COUNT,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_VENUE_DETAILS,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_SEAT_ALLOCATION,
        payload: [],
      });
      dispatch({
        type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
        payload: [],
      });
    };
  }, [dispatch]);
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setFile(file);
  };
  const handleUploadVenue = async () => {
    // setFile(e.target.files[0])
    dispatch({
      type: venueActions.UPLOAD_VENUE_DATA,
      payload: { courseid, file, setOpen, setLoading },
    });
  };
  const ToggleOpen = () => {
    setOpen(!open);
  };
  const onChangeCourse = async (e) => {
    setPcmb(0);
    setCourseId(e.target.value);
  };

  const onSelectCourse = () => {
    if (courseid) {
      dispatch({
        type: venueActions.GET_CANDIDATE_COUNT,
        payload: { courseid: courseid },
      });
      dispatch({
        type: venueActions.GET_VENUE_DETAILS,
        payload: { courseid: courseid },
      });
      dispatch({
        type: venueActions.GET_SEAT_ALLOCATION,
        payload: { courseid: courseid },
      });
      dispatch({
        type: venueActions.GET_CATEGORIES_OF_COURSE,
        payload: { courseid: courseid },
      });
      dispatch({
        type: venueActions.GET_CANDIDATE_ALLOCATION_DEAILS,
        payload: { courseid: courseid },
      });
    }
    return;
  };
  const onError = () => {};
  const onRunPreference = async (data) => {
    let gender = {
      male: data["male"],
      female: data["female"],
      others: data["others"],
    };

    let categoriesArray = [];
    categories.forEach((cat) => {
      categoriesArray.push({ categoryid: cat.value, value: data[cat.id] });
    });
    let others = {
      orphan: data["orphan"],
      pwd: data["pwd"],
      categories: categoriesArray,
    };
    if (
      courseid
      // && (courseList?.all?.find(obj=>obj.courseid == courseid)?.ispcmb ? pcmb : 1)
    ) {
      dispatch({
        type: venueActions.RUN_SEAT_ALLOCATION,
        payload: {
          courseid: courseid,
          preferenceid: preferenceid,
          adminuserid: backofficeTokenDetails?.id,
          isLogicApplied: isLogicApplied,
          getDataInterval: getDataInterval,
          setIntervalId: setIntervalId,
          pcmb: pcmb,
          ispcmb: courseList?.all?.find((obj) => obj.courseid == courseid)
            ?.ispcmb,
          setStatusModalOpen: setStatusModalOpen,
          gender,
          others,
          //   getDataInterval: () =>
          //     socketRef?.current?.emit("listenstatus", { courseid }),
        },
      });
    }
  };
  const handlePreferenceChange = (e) => {
    setPreferenceId(e.target.value);
  };

  const onReset = (courseid, preferenceid = 0) => {
    courseid &&
      dispatch({
        type: venueActions.RESET_SEAT_ALLOCATION,
        payload: { courseid, preferenceid, userid: backofficeTokenDetails?.id },
      });
  };
  const onChangePCMB = (e) => {
    setPcmb(e.target.value);
  };
  const handleLogicAppliedChange = (e) => {
    setIsLogicApplied(e.target.value);
    setValue("male", 0);
    setValue("female", 0);
    setValue("others", 0);
    setValue("pwd", 0);
    setValue("orphan", 0);
    categories.forEach((cat) => {
      setValue(cat.id, 0);
    });
  };
  const handleLogicChange = (e) => {
    setLogic(e.target.value);
    setValue("male", 0);
    setValue("female", 0);
    setValue("others", 0);
  };
  return (
    <>
      <Card
        sx={{
          width: "100%",
          textAlign: "start",
          borderRadius: "8px",
          // cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "none",
          padding: 2,
          background: "none",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="p"
            color="#212121"
            fontWeight={600}
            sx={{ paddingBottom: 2 }}
            component="p"
          >
            Get Allocated Data
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item md={5}>
            <Box>
              <Select
                size="small"
                onChange={onChangeCourse}
                value={courseid}
                defaultValue={0}
                sx={{ width: "100%", minWidth: "200px" }}
              >
                <MenuItem value={0} selected>
                  Courses
                </MenuItem>
                {courseList?.all?.map((course, i) => (
                  <MenuItem key={i} value={course.courseid}>
                    {course.coursename}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item md={5}>
            {courseList?.all?.find((obj) => obj.courseid == courseid)
              ?.ispcmb && (
              <Box>
                <Select
                  size="small"
                  onChange={onChangePCMB}
                  value={pcmb}
                  defaultValue={0}
                  sx={{ width: "100%", minWidth: "200px" }}
                >
                  <MenuItem value={0} selected>
                    Select
                  </MenuItem>
                  <MenuItem value={1}>PCM</MenuItem>

                  <MenuItem key={2} value={2}>
                    PCB
                  </MenuItem>
                </Select>
              </Box>
            )}
          </Grid>
          <Grid item md={2}>
            <BluePrimaryButton
              title="Select"
              handleSubmit={onSelectCourse}
              disabled={!courseid}
            />
          </Grid>
          <Grid item md={12}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <BluePrimaryButton title="Get Venue data(API)" />
              <BluePrimaryButton
                handleSubmit={ToggleOpen}
                title="Browse and Upload Venue data"
              />
              <GreenButton
                handleSubmit={() => xlsx(data, settings, callback)}
                title="Download Template"
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} paddingTop={2}>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateCount || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Candidates"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.venues || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Venues"}
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {venueDetails?.venueCount || 0}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {"Venue Capacity for batch"}
              </Typography>
            </Card>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", paddingTop: 2 }}>
          <Typography
            variant="p"
            color="#212121"
            fontWeight={600}
            sx={{ paddingBottom: 2 }}
            component="p"
          >
            Allocate Venue
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item md={12}>
            <Box>
              {/* <Select
                fullWidth
                defaultValue={0}
                size="small"
                onChange={handlePreferenceChange}
              >
                <MenuItem value={0}>Overall Preference</MenuItem>
                <MenuItem value={1}>Preference 1</MenuItem>
                <MenuItem value={2}>Preference 2</MenuItem>
                <MenuItem value={3}>Preference 3</MenuItem>
                <MenuItem value={4}>Preference 4</MenuItem>
               <MenuItem value={5}>Preference 5</MenuItem> 
              </Select> */}
              <Select
                // fullWidth
                defaultValue={0}
                size="small"
                onChange={handleLogicAppliedChange}
                value={isLogicApplied}
              >
                <MenuItem value={0}>Preference + PWD</MenuItem>
                <MenuItem value={1}>Dynamic Proportion Scheduling</MenuItem>
              </Select>
            </Box>
          </Grid>
          {/* <Grid item md={3}>
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Is Logic Applied
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={isLogicApplied}
                onChange={handleLogicAppliedChange}
                row
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid> */}
          <Grid item md={6}>
            <Grid item md={12}>
              <Typography variant="h5" fontWeight={600}>
                Gender Percentages ( Overall Should be 100%)
              </Typography>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Male
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.male}
                        variant="outlined"
                      >
                        <TextField
                          {...register("male", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              let general = parseFloat(watch("general")) || 0;

                              // trigger("female")
                              // trigger("others")
                              let overall = female + others + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            setValue(
                              "male",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            trigger("female");
                            trigger("others");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.male ? errors.male.message : ""}
                        />

                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.male ? errors.male.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Female
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.female}
                        variant="outlined"
                      >
                        <TextField
                          {...register("female", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let male = parseFloat(watch("male")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              let general = parseFloat(watch("general")) || 0;

                              // trigger("male")
                              // trigger("others")
                              let overall = male + others + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            setValue(
                              "female",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            trigger("male");
                            trigger("others");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.female ? errors.female.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.female ? errors.female.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Others
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.others}
                        variant="outlined"
                      >
                        <TextField
                          {...register("others", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let male = parseFloat(watch("male")) || 0;
                              let general = parseFloat(watch("general")) || 0;
                              // trigger("male")
                              // trigger("female")
                              let overall = female + male + general;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            setValue(
                              "others",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            trigger("male");
                            trigger("female");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.others ? errors.others.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.others ? errors.others.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    General
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.general}
                        variant="outlined"
                      >
                        <TextField
                          {...register("general", {
                            validate: (val) => {
                              let female = parseFloat(watch("female")) || 0;
                              let male = parseFloat(watch("male")) || 0;
                              let others = parseFloat(watch("others")) || 0;
                              // trigger("male")
                              // trigger("female")
                              let overall = female + male + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            setValue(
                              "general",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            trigger("male");
                            trigger("female");
                            trigger("general");
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.others ? errors.others.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.general ? errors.general.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {isLogicApplied != 0 && female + male + others + general != 100 && (
              <p className="" style={{ color: "red" }}>
                {"Gender percentage should be 100"}
              </p>
            )}
          </Grid>
          <Grid item md={6}>
            <Grid item md={12}>
              <Typography variant="h5" fontWeight={600}>
                Other Percentages ( Overall Should be 100%)
              </Typography>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    Orphan
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.orphan}
                        variant="outlined"
                      >
                        <TextField
                          {...register("orphan", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              let pwd = parseFloat(watch("pwd")) || 0;
                              let others = categories.reduce(
                                (acc, curr) => acc + parseFloat(watch(curr.id)),
                                0
                              );

                              let overall = pwd + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          onChange={(e) => {
                            setValue(
                              "orphan",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            // trigger("pwd")
                            trigger("pwd");
                            categories.forEach((cat) => {
                              trigger(cat.id);
                            });
                          }}
                          // onInput={percentageValidation}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.male ? errors.male.message : ""}
                        />

                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.orphan ? errors.orphan.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} mb={1}>
              <Grid container alignItems="center">
                <Grid item md={4}>
                  <Typography variant="body1" fontWeight={600}>
                    PWD
                  </Typography>
                </Grid>
                <Grid item md={8}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 4,
                    }}
                  >
                    <Box>
                      <FormControl
                        fullWidth
                        error={!!errors.pwd}
                        variant="outlined"
                      >
                        <TextField
                          {...register("pwd", {
                            // required: "This is a required Field *",
                            validate: (val) => {
                              // let pwd = parseFloat(watch("pwd")) || 0;
                              let orphan = parseFloat(watch("orphan")) || 0;
                              let others = categories.reduce(
                                (acc, curr) => acc + parseFloat(watch(curr.id)),
                                0
                              );
                              let overall = orphan + others;
                              return percentageValidation(
                                parseFloat(val),
                                overall
                              );
                            },
                            disabled: parseInt(isLogicApplied) !== 1,
                          })}
                          // onInput={percentageValidation}
                          onChange={(e) => {
                            setValue(
                              "pwd",
                              (parseFloat(e.target.value) || 0) * 1
                            );
                            // trigger("pwd")
                            trigger("orphan");
                            categories.forEach((cat) => {
                              trigger(cat.id);
                            });
                          }}
                          defaultValue={0}
                          inputProps={{
                            style: { fontWeight: 600, textAlign: "center" },
                          }}
                          // helperText={errors.pwd ? errors.pwd.message : ""}
                        />
                        <span
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.pwd ? errors.pwd.message : ""}
                        </span>
                      </FormControl>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {categories?.map((item) => {
              return (
                <Grid item md={12} mb={1}>
                  <Grid container alignItems="center">
                    <Grid item md={4}>
                      <Typography variant="body1" fontWeight={600}>
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid item md={8}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 4,
                        }}
                      >
                        <Box>
                          <FormControl
                            fullWidth
                            error={!!errors[item.id]}
                            variant="outlined"
                          >
                            <TextField
                              {...register(item.id, {
                                // required: "This is a required Field *",
                                validate: (val) => {
                                  let pwd = parseFloat(watch("pwd")) || 0;
                                  let orphan = parseFloat(watch("orphan")) || 0;
                                  let others = categories
                                    .filter((cat) => cat.id !== item.id)
                                    .reduce(
                                      (acc, curr) =>
                                        acc + parseFloat(watch(curr.id)),
                                      0
                                    );
                                  let overall = pwd + orphan + others;
                                  return percentageValidation(
                                    parseFloat(val),
                                    overall
                                  );
                                },
                                disabled: parseInt(isLogicApplied) !== 1,
                              })}
                              onChange={(e) => {
                                setValue(
                                  item.id,
                                  (parseFloat(e.target.value) || 0) * 1
                                );
                                trigger("pwd");
                                trigger("orphan");
                                categories
                                  .filter((cat) => cat.id !== item.id)
                                  .forEach((cat) => {
                                    trigger(cat.id);
                                  });
                              }}
                              // onInput={percentageValidation}
                              defaultValue={0}
                              inputProps={{
                                style: { fontWeight: 600, textAlign: "center" },
                              }}
                              // helperText={errors.male ? errors.male.message : ""}
                            />

                            <span
                              className="error"
                              style={{ color: "red", fontSize: "12px" }}
                            >
                              {errors[item.id] ? errors[item.id].message : ""}
                            </span>
                          </FormControl>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
            {parseInt(isLogicApplied) !== 0 &&
              (() => {
                const orphan = parseFloat(watch("orphan")) || 0;
                const pwd = parseFloat(watch("pwd")) || 0;
                const others = categories.reduce(
                  (acc, curr) => acc + (parseFloat(watch(curr.id)) || 0),
                  0
                );
                const total = orphan + pwd + others;

                return total < 100 ? (
                  <p style={{ color: "red" }}>
                    Overall percentage should be 100.
                  </p>
                ) : null;
              })()}
          </Grid>

          <Grid item md={12}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <BluePrimaryButton
                title="Run"
                // disabled={
                //   !candidateCount ||
                //   candidateCount <= 0 ||
                //   (isLogicApplied != 0 &&
                //     female + male + others + general != 100)
                // }
                disabled={
                  !candidateCount ||
                  candidateCount <= 0 ||
                  (parseInt(isLogicApplied) !== 0 &&
                    (female + male + others + general !== 100 ||
                     (parseFloat(watch("orphan")) || 0) +
                       (parseFloat(watch("pwd")) || 0) +
                       categories.reduce((acc, curr) => acc + (parseFloat(watch(curr.id)) || 0), 0) != 100))
                }
                
                handleSubmit={handleSubmit(onRunPreference, onError)}
              />
              <BluePrimaryButton
                title="Reset Data"
                handleSubmit={() => onReset(courseid, preferenceid)}
              />
              {/* <GreenButton title="Download Venue Template" /> */}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", textAlign: "center" }} paddingTop={2}>
          <CommonTable tableData={seatAllocationData} columnData={columnData} />
        </Box>
        <Grid container spacing={2} paddingTop={2}>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.allocated &&
                  candidateAllocationDetails?.allocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(candidateAllocationDetails?.allocated[0])
                      .length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.allocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.allocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "Allocated Candidate Details",
                      columns: columns,
                      content: candidateAllocationDetails?.allocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "Allocated Candidates" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.allocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Allocated Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );
                if (
                  candidateAllocationDetails?.notallocated &&
                  candidateAllocationDetails?.notallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(candidateAllocationDetails?.notallocated[0])
                      .length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.notallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.notallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "notallocated Candidate Details",
                      columns: columns,
                      content: candidateAllocationDetails?.notallocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "notallocated Candidates" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.notallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Non Allocated Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.disabilityallocated &&
                  candidateAllocationDetails?.disabilityallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    ).length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.disabilityallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "disabilityallocated",
                      columns: columns,
                      content: candidateAllocationDetails?.disabilityallocated,
                    },
                  ];
                  xlsx(
                    data,
                    { ...settings, fileName: "disabilityallocated" },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.disabilityallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Allocated Disability Candidates
              </Typography>
            </Card>
          </Grid>
          <Grid item md={2} sm={4}>
            <Card
              onClick={() => {
                // candidateAllocationDetails?.allocated.length > 0 &&
                // xlsx(
                //   candidateAllocationDetails?.allocated,
                //   { ...settings, fileName: "Allocated Candidates" },
                //   callback
                // );

                if (
                  candidateAllocationDetails?.disabilitynotallocated &&
                  candidateAllocationDetails?.disabilitynotallocated.length > 0
                ) {
                  let columns = [];

                  for (
                    let i = 0;
                    i <
                    Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    ).length;
                    i++
                  ) {
                    let obj = {};
                    obj.label = Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    )[i];
                    obj.value = Object.keys(
                      candidateAllocationDetails?.disabilitynotallocated[0]
                    )[i];
                    columns.push(obj);
                  }

                  let data = [
                    {
                      sheet: "Non Allocated Disability",
                      columns: columns,
                      content:
                        candidateAllocationDetails?.disabilitynotallocated,
                    },
                  ];
                  xlsx(
                    data,
                    {
                      ...settings,
                      fileName: "disabilitynotallocated Candidates",
                    },
                    callback
                  );
                } else {
                }
              }}
              sx={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "none",
                padding: 2,
                border: `1px solid ${cssProperties.bordercolor.secondary}`,
              }}
            >
              <Typography
                variant="p"
                color={cssProperties.color.failure}
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                {candidateAllocationDetails?.disabilitynotallocated.length}
              </Typography>
              <Typography
                variant="p"
                color="#212121"
                fontWeight={600}
                sx={{ paddingBottom: 2 }}
                component="p"
              >
                Non Allocated Disability Candidates
              </Typography>
            </Card>
          </Grid>
        </Grid>

        {/* <Grid container paddingTop={2} justifyContent="end">
                    <Grid item>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'end' }}>
                            <DangerButton title="Get Candidate data(API)" />
                            <DangerButton title="Browse and Upload Candidate Data" />
                            <DangerButton title="Download candidate data " />

                        </Box>
                    </Grid>
                </Grid> */}
      </Card>
      <Modal
        open={open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {file ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{file?.name}</Box>
              <Box
                onClick={() => setFile(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={ToggleOpen}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading || !file || courseid === 0}
              handleClick={handleUploadVenue}
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
    </>
  );
};

export default Index;
